module.exports = __webpack_public_path__ + "img/Blog-app.0060ecf7.png";